export function applicantPayload(qualification, payload) {
  const educationList = payload?.education || [];

  return {
    applicant: {
      id: payload.id || "",
      name: payload.name || "",
      dob: payload.dob || "",
      gender: payload.gender || "",
      mobile_prefix: payload.mobile_prefix || "",
      mobile_no: payload.mobile_no || "",
      whatsapp_mobile_no: payload.whatsapp_mobile_no || "",
      whatsapp_mobile_prefix: payload.whatsapp_mobile_prefix || "",
      email: payload.email || "",
      alternate_email: payload.alternate_email || "",
      country_id: payload.country_id || "",
      religion_id: payload.religion_id || "",
      caste_id: payload.caste_id || "",
      program_id: payload.program_id || "",
      community_id: payload.community_id || "",
      residence: payload.residence || "true",
      pan_card_no: payload.pan_card_no || "",
      aadhar_card_no: payload.aadhar_card_no || "",
      abc_id: payload.abc_id || "",
      deb_id:
        payload.deb_id == "invalid" || payload.deb_id == "null"
          ? ""
          : payload.deb_id,
      deb_validated: payload.deb_validated || false,
      deb_invalid: payload.deb_invalid || false,
      deb_different: payload.deb_different || false,
      indian_air_force: payload.indian_air_force || "false",
      passport_number: payload.passport_number || "",
      passport_date_of_issue: payload.passport_date_of_issue || "",
      passport_place_of_issue: payload.passport_place_of_issue || "",
      family: {
        relationship: payload?.family?.relationship || "",
        name: payload?.family?.name || "",
        relation_type: payload?.family?.relation_type || "",
        mobile_prefix: payload?.family?.mobile_prefix || "+91",
        mobile_no: payload?.family?.mobile_no || "",
        email: payload?.family?.email || "",
      },
      aadhar: payload.aadhar || {},
      photo: payload.photo || {},
      pan: payload.pan || {},
      id_card: payload.id_card || {},
      employment_letter: payload.employment_letter || {},
      kovida_certificate: payload.kovida_certificate || {},
      photoImage: payload.photoImage || null,
      aadharImage: payload.aadharImage || null,
      idCard: payload.idCard,
      employmentLetter: payload.employmentLetter,
      kovidaCertificate: payload.kovidaCertificate || null,
      panImage: payload.panImage || null,
      is_pan_attached: payload.is_pan_attached || false,
      is_aadhar_attached: payload.is_aadhar_attached || false,
      is_id_card_attached: payload.is_id_card_attached || false,
      is_employment_letter_attached:
        payload.is_employment_letter_attached || false,
      is_kovida_certificate_attached: payload.is_kovida_certificate_attached || false,
      is_permanent_address_same: payload.is_permanent_address_same || false,
      completion_status: payload.completion_status,
      application_status: payload.application_status,
      step: payload.step || 0,
      agree: payload.agree || false,
      partner_name: payload.partner_name || "",
      partner_code: payload.partner_code || "",
      partner_type: payload.partner_type || "",
      partner_id: payload.partner_id || "",
      partner_branch_id: payload.partner_branch_id || "",
      partner_approval_required: payload.partner_approval_required || false,
      partner_approval_status: payload.partner_approval_status || "",
      partner_payment_required: payload.partner_payment_required,
      year: payload.year || "",
      batch: payload.batch || "",
      pre_app_fee: payload.pre_app_fee || "",
      partner_branch_code: payload.partner_branch_code || "",
      application_id: payload.application_id || "",
      deb_map: payload.deb_map || {},
      occupation: payload.occupation || "",
      company_name: payload.company_name || "",
      employee_id: payload.employee_id || "",
      employee_email_id: payload.employee_email_id || "",
      program_batch_id: payload.program_batch_id || "",
      batch_partner_schedule_id: payload.batch_partner_schedule_id || "",
      batch_partner_course_fee_id: payload.batch_partner_course_fee_id || "",
      sp_acceptance: payload.sp_acceptance || false,
    },

    address: {
      permanent_address: {
        is_indian_address:
          payload?.permanent_address?.is_indian_address || true,
        address_line1: payload?.permanent_address?.address_line1 || "",
        address_line2: payload?.permanent_address?.address_line2 || "",
        city: payload?.permanent_address?.city || "",
        state: payload?.permanent_address?.state || "",
        country: payload?.permanent_address?.country || "",
        postcode: payload?.permanent_address?.postcode || "",
        locality: payload?.permanent_address?.locality || "",
      },
      current_address: {
        is_indian_address: true,
        address_line1: payload?.current_address?.address_line1 || "",
        address_line2: payload?.current_address?.address_line2 || "",
        city: payload?.current_address?.city || "",
        state: payload?.current_address?.state || "",
        country: payload?.current_address?.country || "",
        postcode: payload?.current_address?.postcode || "",
        locality: payload?.current_address?.locality || "",
      },
      is_permanent_address_same: payload.is_permanent_address_same || "false",
    },
    education: qualification
      .map((edu) => {
        const existingData =
          educationList?.find((item) => item.qualification_id === edu.id) || {};
        return {
          name_of_institution: existingData.name_of_institution || "",
          // board: existingData.board || "",
          // location: existingData.location || "",
          // result_type: existingData.result_type || "marks",
          // marks_obtained: existingData.marks_obtained || "",
          // total_marks: existingData.total_marks || "",
          // grade: existingData.grade || "",
          qualification_id: edu.id,
          qualification_name: edu.name,
          qualification_order: edu.level,
          upload_image: payload[existingData.qualification_id] || null,
          upload_certificate:
            payload[existingData.qualification_id + "_certificate"] || null,
          is_attached: payload[existingData.qualification_id] ? true : false,
          is_attached_certificate: payload[
            existingData.qualification_id + "_certificate"
          ]
            ? true
            : false,
          id: existingData.id || null,
          completion_status: payload.completion_status || "",
        };
      })
      .sort((a, b) => a.qualification_order - b.qualification_order),
  };
}
